import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators';
import { login, getUserInfo, switchBrand } from '@/api/users';
import { getToken, setToken, removeToken, getRoleToken, setRoleToken, setBrand, getBrand, removeBrand } from '@/utils/cookies';
import store from '@/store';
import Router from '@/router';
import { iBrand } from '@/interface/result';

export interface IUserState {
  token: string;
  name: string;
  avatar: string;
  introduction: string;
  roles: string[];
  brands?: iBrand[];
  activeBrand?: string;
}

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements IUserState {
  public token = getToken() || '';
  public name = sessionStorage.getItem('omc_lg_un') || '';
  public avatar = '';
  public introduction = '';
  // public roles: string[] = localStorage.getItem('role') ? JSON.parse(localStorage.getItem('role')!) : [];
  roles: string[] = getRoleToken() ? JSON.parse(getRoleToken()!) : [];

  brands: iBrand[] = JSON.parse(localStorage.getItem('brands')!);
  public activeBrand = getBrand() || '';

  @Mutation
  private SET_BRANDS(brands: iBrand[]) {
    this.brands = brands;
  }

  @Mutation
  private SET_ACTIVE_BRAND(activeBrand?: string) {
    if (activeBrand) {
      this.activeBrand = activeBrand;
    }
  }

  @Mutation
  private SET_TOKEN(token: string) {
    this.token = token;
    localStorage.setItem('omc_lg_tk', token);
  }

  @Mutation
  private SET_NAME(name: string) {
    this.name = name;
    sessionStorage.setItem('omc_lg_un', name);
  }

  @Mutation
  private SET_AVATAR(avatar: string) {
    this.avatar = avatar;
  }

  @Mutation
  private SET_INTRODUCTION(introduction: string) {
    this.introduction = introduction;
  }

  @Mutation
  private SET_ROLES(roles: string[]) {
    this.roles = roles;
    // localStorage.setItem('role', JSON.stringify(roles));
    setRoleToken(JSON.stringify(roles));
  }

  @Action
  public async Login(userInfo: { username: string; password: string; captcha: string; tid: string }) {
    let { username, password, captcha, tid } = userInfo;
    username = username.trim();
    try {
      const res = await login({ username, captcha, tid, pwd: password });
      if (res && res.data) {
        setToken(res.data.token);
        this.SET_NAME(res.data.username);
        this.SET_TOKEN(res.data.token);
        this.SET_ROLES([res.data.role || 'admin']);
        if (res.data.app_ids) {
          this.SET_BRANDS(res.data.app_ids);
          this.SET_ACTIVE_BRAND(res.data.default_app_id);
          localStorage.setItem('brands', JSON.stringify(res.data.app_ids));
          setBrand(res.data.default_app_id || '');
        }
        Router.push({
          path: '/',
        });
      }
    } catch (error) {
      this.ResetToken();
      console.log('action login', error);
    }
  }

  @Action
  public ResetToken() {
    removeToken();
    this.SET_TOKEN('');
    this.SET_ROLES([]);
  }

  @Action
  public brandSwitch(params: { app_id: string; is_default: boolean }): Promise<any> {
    return new Promise<void>((resolve, reject) => {
      switchBrand(params)
        .then(resp => {
          setBrand(params.app_id);
          if (resp && resp.data) {
            if (!resp.data.token) {
              return reject();
            }

            setToken(resp.data.token);
            this.SET_TOKEN(resp.data.token);
            this.SET_NAME(resp.data.username);
            this.SET_ROLES([resp.data.role || 'admin']);
            if (resp.data.app_ids) {
              this.SET_BRANDS(resp.data.app_ids);
              this.SET_ACTIVE_BRAND(resp.data.default_app_id);
              localStorage.setItem('brands', JSON.stringify(resp.data.app_ids));
            }
          }
          resolve();
        })
        .catch(err => {
          console.error(err);
          reject();
        });
    });
  }

  @Action
  public async GetUserInfo() {
    if (this.token === '') {
      throw Error('GetUserInfo: token is undefined!');
    }
    const { data } = await getUserInfo({
      /* Your params here */
    });
    if (!data) {
      throw Error('Verification failed, please Login again.');
    }
    const { roles, name, avatar, introduction } = data.user;
    // roles must be a non-empty array
    if (!roles || roles.length <= 0) {
      throw Error('GetUserInfo: roles must be a non-null array!');
    }
    this.SET_ROLES(roles);
    this.SET_NAME(name);
    this.SET_AVATAR(avatar);
    this.SET_INTRODUCTION(introduction);
  }

  @Action
  public LogOut() {
    if (this.token === '') {
      throw Error('LogOut: token is undefined!');
    }
    this.SET_NAME('');
    removeToken();
    this.SET_TOKEN('');
    this.SET_ROLES([]);
    localStorage.removeItem('brands');
    removeBrand();
  }
}

export const UserModule = getModule(User);
